import { render } from "./QuestionnaireView.vue?vue&type=template&id=3bf6eb8e"
import script from "./QuestionnaireView.vue?vue&type=script&lang=js"
export * from "./QuestionnaireView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__